"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionContent = void 0;
var react_1 = __importDefault(require("react"));
var getText_1 = require("../../../../utils/getText");
var genProfileImg_1 = require("../../utils/genProfileImg");
var genIcon_1 = require("../../utils/genIcon");
var Typo_1 = require("../../../Typo");
var styled_components_1 = require("styled-components");
var genColor_1 = require("../../utils/genColor");
var OptionContent = function (_a) {
    var option = _a.option, optionsClassName = _a.optionsClassName, invert = _a.invert, S = _a.S, observerRef = _a.observerRef;
    var theme = (0, styled_components_1.useTheme)();
    var TypoComp = S ? Typo_1.SANS_2 : Typo_1.SANS_3;
    var image = option.image, display = option.display, icon = option.icon, desc = option.desc, color = option.color;
    return (react_1.default.createElement("div", { ref: observerRef, style: {
            display: "flex",
            alignItems: "flex-start",
            gap: "1rem",
            maxWidth: "36rem",
        } },
        (image || icon || color) &&
            react_1.default.createElement("div", { style: { marginTop: desc && '0.2rem', display: 'flex', alignContent: 'center' } },
                image && (0, genProfileImg_1.genProfileImg)({ image: image, display: display, invert: invert, theme: theme }),
                icon && (0, genIcon_1.genIcon)({ icon: icon, invert: invert, S: S }),
                color && (0, genColor_1.genColor)({ color: color })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(TypoComp, { invert: invert, semibold: desc ? true : false, className: "OKE-Dropdown__optionText ".concat(optionsClassName || "") }, (0, getText_1.getText)(display)),
            desc && (react_1.default.createElement(TypoComp, { invert: invert, className: "OKE-Dropdown__optionDesc" }, (0, getText_1.getText)(desc))))));
};
exports.OptionContent = OptionContent;
